import { ContinueWatchingItem } from '#store/namespaces/continue-watching/state';
import { Context } from '#store/overmind';
import { logger } from '#utils';
import { UpdateContinueWatchingItemParams } from '#types';

export const loadWatchList = async ({ state, effects }: Context) => {
  try {
    state.continueWatching.items = await effects.continueWatching.api.getAll(
      state.user.profile.id
    );
  } catch (e) {
    logger.warn('Problem on loading user watchlist', e);
  }
};

export const updateItem = async (
  { state, effects },
  payload: UpdateContinueWatchingItemParams
) => {
  const items = state.continueWatching.items.filter(
    (entry: ContinueWatchingItem) => entry.mediaIri !== payload.mediaIri
  );

  if (state.user.profile && state.user.profile.id) {
    const item = await effects.continueWatching.api.updateItem(
      state.user.profile.id,
      payload
    );
    state.continueWatching.items = [{ ...item }, ...items];
    return;
  }

  state.continueWatching.items = [
    { id: payload.mediaIri, ...payload },
    ...items,
  ];
};
